// Copyright (c) 2026 Goffy. All Rights Reserved.

// Web has no push yet: the same API, doing nothing, so callers need no platform checks and the
// web bundle never pulls in the native notification modules.

import { actionForPushData, type PushTapAction } from './pushTapAction';

export { actionForPushData, type PushTapAction };

export const ANDROID_CHANNEL_ID = 'default';

export async function registerForPushNotifications(
  _apiBaseUrl: string,
  _authToken: string,
  _channelName: string
): Promise<boolean> {
  return false;
}

export async function unregisterFromPushNotifications(_apiBaseUrl: string, _authToken: string): Promise<void> {}

export function subscribeToNotificationTaps(_onTap: (action: PushTapAction) => void): () => void {
  return () => undefined;
}

export function subscribeToPushTokenChanges(_onChange: () => void): () => void {
  return () => undefined;
}
